/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import { Exemption, Individu } from '@/types';
import useTrimestreStore from '@/zustand/useTrimestreStore';

const validationRecensement = (
  data: Partial<Individu>,
  exemptionActive: boolean,
) => {
  const trimestreActif = useTrimestreStore.getState().trimestre;
  
  const errors = {
    trimestreRecensement: '',
    anneeRecensement: '',
    dateRecensement: '',
    recensement: '',
    demandeExemption: '',
  };

  const anneeActuelle = new Date().getFullYear();

  if (_.isNil(data?.trimestreRecensement) || data?.trimestreRecensement === 0) {
    errors.trimestreRecensement = 'Le trimestre de recensement est obligatoire';
  }

  if (_.isNil(data?.anneeRecensement) || data?.anneeRecensement === 0) {
    errors.anneeRecensement = 'L\'année est obligatoire';
  }

  if (_.toNumber(data?.anneeRecensement) < 1900
    || _.toNumber(data?.anneeRecensement) > anneeActuelle + 1) {
    errors.anneeRecensement = 'L\'année est invalide';
  }

  if (data?.anneeRecensement != new Date(data?.dateRecensement).getFullYear()) {
    errors.anneeRecensement = 'L\'année saisie ne correspond pas à celle de la date de recensement';
  }

  if (!_.isNil(trimestreActif)) {
    const { annee: anneeActive, periode: periodeActive } = trimestreActif;
    const anneeRecensement = _.toNumber(data?.anneeRecensement);
    const trimestreRecensement = data?.trimestreRecensement;
    
    const isTrimestreAnterieur = 
      anneeRecensement < anneeActive || 
      (anneeRecensement === anneeActive && trimestreRecensement < periodeActive);
    
    if (isTrimestreAnterieur) {
      errors.trimestreRecensement = `Impossible de créer un recensé pour un trimestre cloturé`;
    }
  }

  if (_.isEmpty(data?.recensement)) {
    errors.recensement = 'L\'inscription à la liste est obligatoire';
  }

  if (exemptionActive && data?.demandeExemption === Exemption.SansObjet) {
      errors.demandeExemption = 'Vous devez sélectionner un motif de demande d\'exemption';
  }

  return _.pickBy(errors, (value) => value !== '');
};

export default validationRecensement;
